import { getMultiStepQuizV2WithLoaderTemplate, getMultiStepQuizV2Template } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";

/**
 *  When user clicks on a shortcode to edit it
 */
const editMultiStepQuizV2Config = (editor, shortcodeWrapper) => {
  let currentData = null;
  const withLoader = shortcodeWrapper.querySelector(".v2-quiz-edit").dataset?.noLoader === "true" ? false : true;

  const multiStepQuizV2Window = editor.windowManager.openUrl({
    title: withLoader ? "Multi-Step Quiz #2 With Loader" : "Multi-Step Quiz #2",
    url: "/multi-step-quiz-v2-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute("data-multi-step-quiz-data", currentData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      /**
       * requestData message is sent whenever the MultiStepQuizV2Dialog mounts. It requests quiz data
       * so that we don't have to pass it through URL params (which adds/removes encoding randomly, cuts off parts of json etc.)
       */
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateData") {
        currentData = message.data;
      }
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });

  const sendData = () => {
    multiStepQuizV2Window.sendMessage({
      type: "sendData",
      data: shortcodeWrapper.getAttribute("data-multi-step-quiz-data"),
    });
  };
};

/**
 * when user adds shortcode initially
 */
const multiStepQuizV2Config = (tinymce, uuid, shortcodeOnClick, withLoader = false) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: withLoader ? "Multi-Step Quiz #2 With Loader" : "Multi-Step Quiz #2",
    url: "/multi-step-quiz-v2-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      let templateToAdd;

      if (withLoader) {
        templateToAdd = getMultiStepQuizV2WithLoaderTemplate(currentData);
      } else {
        templateToAdd = getMultiStepQuizV2Template(currentData);
      }

      // This is a string for now. We have to convert it to DOM element to be able to set data attribute.
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd, "multi-step-quiz-v2");
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute("data-multi-step-quiz-data", currentData);

      // Have to invert here, since there's already multi-step-quiz-v2 shortcodes created in production, and
      // They should all remain with a loader.
      if (!withLoader) {
        shortcodeWrapperEl.setAttribute("data-no-loader", true);
      }

      // Since we have to pass a string representation of DOM element, pass outerHTML of shortcodeWrapper
      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { multiStepQuizV2Config, editMultiStepQuizV2Config };
